import { fetchCurrentUserData, customFetch } from "@/util/customFetch";
import { fetchUserAttributes } from "@aws-amplify/auth";
import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";

// sample data imports for offline dev purposes
const isOfflineDev = import.meta.env.VITE_OFFLINE_DEV === "true";
const {userPermissions} = isOfflineDev ? await import("@/tests/fixtures/UserPermissions.js") : {};
const {tenantEmployees} = isOfflineDev ? await import("@/tests/fixtures/Employees.js") : {};

export async function login(token) {
  console.log(token)
 /** return fetch('/api/user/login', {
    method: 'POST',
    headers: {'Content-Type': 'application/json', 'accesstoken': `${await fetchCurrentUserData()}`},
    body: JSON.stringify({token})
  })
    .then(res => res.json()
    .then(data => { return data })
  )**/
}

/**
 *
 * @param email
 * @returns {Promise<unknown>}
 */
export async function getUser(email) {
  let tokenData = await fetchCurrentUserData()
  return fetch(BACKEND_API_PLACEHOLDER +`/api/v1/users/email?email=${encodeURIComponent(email)}`, {
    method: 'GET',
    headers: {
      ...tokenData,
    },
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

/**
 *
 * @param user_id
 * @param tenant_id
 * @returns {Promise<unknown>}
 */
export async function getEmployeesByUserIdAndTenantId(user_id, tenant_id) {
  return customFetch(BACKEND_API_PLACEHOLDER + `/api/v1/users/?user=${user_id}&tenant=${tenant_id}`, 'GET');
}

export async function getEmployeesList(user_id) {
  let tokenData = await fetchCurrentUserData()
    return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/employees/?user=${user_id}`, {
      method: 'GET',
      headers: { ...tokenData },
    })
      .then(res => res.json()
      .then(data => { return data })
    )
    // return customFetch(BACKEND_API_PLACEHOLDER + `/api/v1/employees/?user=${user_id}`, 'GET');
}

export async function getEmployeesInTenant(headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + '/api/v1/users/getUsersInTenant', {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return { status: 200, data: tenantEmployees }
}

export async function getPermissions(site_id){
        // Blank Cognito Data
        let cognitoData;
        // Check with Cognito to get our Current user via Cognito Cookies
        try {
          cognitoData = await fetchUserAttributes();
          console.log(cognitoData);
        } catch (error) {
          console.error("Error fetching user:", error);
          return null;
        }
        // Check with Portal API to get our real user
        let user
        await getUser(cognitoData.email)
        .then(response => {
          if (response.status == 200 && Array.isArray(response.data) && response.data.length > 0) {
            user = response.data[0]
          }
          else {
            console.error(response)
            return []
          }
        })
        let myEmployees = (await getEmployeesList(user.id))?.data?.results || [];
        console.log(myEmployees)
        return myEmployees.find(element => element.site_id == site_id).permissions;
}

export async function getEmployeePermissions(headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + '/api/v1/users/permissions', {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return {
    results: userPermissions,
    user_data: {
      is_tenant_super: true,
      user_management: true
    }
  }
}

export async function inviteUser(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/v1/users/invite_user', {
    method: 'POST',
    body: JSON.stringify({postRequest}),
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}


/**
 *
 * @param user_id
 * @param site_id
 * @returns {Promise<unknown>}
 */
export async function getEmployeeSite(user_id, site_id) {
    return customFetch(BACKEND_API_PLACEHOLDER + `/api/v1/employees/?user=${user_id}&site=${site_id}`, 'GET');
}
